import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion"
import { useNavigate } from 'react-router-dom'
import { ReactSVG } from 'react-svg'

import './refractsalepage.css' // Inheriting the premium V2 physics and styling

import duckProductImage from '../assets/DuckProduct2.jpg'
import TsSliders from '../assets/TSSliders2.svg'

import vstimg from '../assets/VSTLogoTs.png'
import auimg from '../assets/AULogoTS.png'
import aaximg from '../assets/AAXLogoTS.png'

import { UserAuth } from '../context/AuthContext'
import { analytics } from '../firebase'
import { logEvent } from 'firebase/analytics'

const DuckSalepage = () => {
    const [alreadyOwnesProduct, setAlreadyOwnesProduct] = useState(false);
    const [allOwnedProducts, setAllOwnedProducts] = useState([]);

    const { user } = UserAuth();
    const navigate = useNavigate();

    // Price for Duck
    const price = 19.99;
    const originalPrice = 29.99;

    useEffect(() => {
        // Check if user owns Duck
        const hasDuck = allOwnedProducts.some((product) => product.name === "duck");
        if (hasDuck) {
            setAlreadyOwnesProduct(true);
        }
    }, [allOwnedProducts])


    const buyProduct = () => {
        logEvent(analytics, "SalePage_Duck_BuyNow");
        navigate('/checkout', { state: { product: { id: 3, name: "Duck", price: price, originalPrice: originalPrice, img: duckProductImage } } });
    };

    return (
        <div className='refractsalepage__container'>
            <div className="refractsalepage__ontop">

                <motion.div className="refractsalepage__prodimg"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <img src={duckProductImage} alt="Duck Hardware" className='ducksalepage__pluginimgsize' />
                </motion.div>

                <div className="refractsalepage__prodinfo">
                    <div className="refractsalepage__leftside">
                        <motion.div className="refractsalepage__title"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            Duck
                        </motion.div>

                        <motion.div className="refractsalepage__description"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                        >
                            Duck is a plugin host that can host all your favorite reverb, delays and effects plugins and makes it simple to duck the effect to the input signal, perfect for creating space while having large reverbs, or making space inbetween delays to reduce automation or time spent side chain routing. It is the fastest way to achieve this effect.
                        </motion.div>
                    </div>

                    <motion.div className="refractsalepage__sliders"
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.6, duration: 0.5 }}
                    >
                        <ReactSVG src={TsSliders} className="refractsalepage__sliderssize" />
                    </motion.div>

                    <div className="refractsalepage__rightside">
                        <motion.div className="refractsalepage__titleright"
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            Volume Envelopes
                        </motion.div>

                        <motion.div className="refractsalepage__price"
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                        >
                            <span>${originalPrice}</span> ${price}
                        </motion.div>

                        <motion.div className="refractsalepage__addtocartbutton"
                            onClick={buyProduct}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6 }}
                        >
                            <div className="refractsalepage__buttontext">
                                {alreadyOwnesProduct ? "Owned" : "Buy Now"}
                            </div>

                        </motion.div>

                        <motion.div className="refractsalepage__addtocartbuttonphone"
                            onClick={buyProduct}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6 }}
                        >
                            <div className="refractsalepage__buttontext">
                                {alreadyOwnesProduct ? "Owned" : "Buy Now"}
                            </div>

                        </motion.div>

                    </div>
                </div>

                {/* Powerful Features Section */}
                <motion.div className="refractsalepage__featurebox"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                >
                    <div className="refractsalepage__featuretitle">Duck any Reverb/Delay in Seconds</div>
                    <div className="refractsalepage__featuregrid">
                        <div className="refractsalepage__featureitem">
                            <h3>Effects Hosting</h3>
                            <p>Host all your favorite reverb, delay, and spatial effects plugins directly inside Duck for seamless ducking manipulation without any external routing.</p>
                        </div>
                        <div className="refractsalepage__featureitem">
                            <h3>Instant Space</h3>
                            <p>Automatically duck the wet effect against the dry input signal. Perfect for creating massive, pristine space while maintaining perfectly focused and punchy mixes.</p>
                        </div>
                        <div className="refractsalepage__featureitem">
                            <h3>Reduce Automation</h3>
                            <p>Dynamically carve out space in between long delays and tails, effortlessly reducing time spent doing tedious volume automation or complex side-chain routing.</p>
                        </div>
                        <div className="refractsalepage__featureitem">
                            <h3>Lightning Fast Workflow</h3>
                            <p>Stop wasting time configuring multi-channel routing. Duck is a completely contained environment, serving as the absolute fastest way to achieve a professional ducking effect.</p>
                        </div>
                    </div>
                </motion.div>

                <div className="refractsalepage__moreinfo">
                    <motion.div className="refractsalepage__infobox"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                    >
                        <div className="refractsalepage__infoboxtitle">
                            Requirements
                        </div>
                        <div className="refractsalepage__infoboxtext">
                            macOS
                            macOS 10.13 or higher (64-bit only)
                            AU or VST3 host or Pro Tools
                            Apple Silicon or Intel processor
                            <br /><br />
                            The computer must be connected to the internet at the time of product registration. After the completion of registration, the software is designed to function offline.
                            <br /><br />
                            Windows support coming soon...
                        </div>
                    </motion.div>

                    <motion.div className="refractsalepage__infobox"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 }}
                    >
                        <div className="refractsalepage__infoboxtitle">
                            Plug-in formats
                        </div>
                        <div className="refractsalepage__infoboxtext">
                            Tape Signal plug-ins are available
                            in VST, VST3, Audio Units, AAX Native
                            and AudioSuite formats.
                        </div>
                        <div className="refractsalepage__formatimgs">
                            <img src={vstimg} alt="VST" />
                            <img src={auimg} alt="AU" />
                            <img src={aaximg} alt="AAX" />
                        </div>
                    </motion.div>
                </div>

            </div>
        </div>
    )
}

export default DuckSalepage
